import React, { createContext, useContext, useEffect, useState } from "react";

import { api } from "../../../services/Api";
import checarData from "../../../utils/checarData";
import formatDateBD from "../../../utils/formatarDataBD";
import { IntervaloDataContext } from "./IntevervaloDataContext";

const NotasFiscaisContext = createContext();

const normalizarPorcentagem = (porcentagem) => {
  if (typeof porcentagem === "string") {
    const parsed = Number(porcentagem.replace(",", "."));
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const normalizaNotaFiscal = (nota) => ({
  id: nota.codigoNota ?? nota.nunota,
  nota_fiscal: nota.numeroNotaFiscal ?? nota.nunota,
  valor: nota.valorLiquido ?? nota.valorBruto,
  data: nota.dataNegociacao,
  codigo_nota: nota.codigoNota ?? nota.codigoEmpresa,
  convenio: nota.parceiro.nome,
});

const normalizaCompetencia = (item) => ({
  competencia: item.competencia ?? "",
  porcentagem: normalizarPorcentagem(item.porcentagem),
});

function NotasFiscaisContextProvider({ children }) {
  const { dataInicio, dataFim } = useContext(IntervaloDataContext);

  const [totalValorNotasSankhya, setTotalValorNotasSankhya] = useState(0);
  const [notasFiscaisTabela, setNotasFiscaisTabela] = useState([]);
  const [loadingNotasFiscais, setLoadingNotasFiscais] = useState(false);

  async function buscarCompetenciasNota({ codigoNota, numeroNota }) {
    const { data } = await api.get(
      `/v2/faturamento/notasFiscais/${encodeURIComponent(
        codigoNota,
      )}/${encodeURIComponent(numeroNota)}/competencias`,
    );

    const lista = Array.isArray(data) ? data : (data?.competencias ?? []);
    return lista.map(normalizaCompetencia);
  }

  async function salvarCompetenciasNota({
    codigoNota,
    numeroNota,
    competencias,
  }) {
    const payload = {
      competencias: competencias.map((item) => ({
        competencia: item.competencia,
        porcentagem: Number(item.porcentagem),
      })),
    };

    const { data } = await api.put(
      `/v2/faturamento/notasFiscais/${encodeURIComponent(
        codigoNota,
      )}/${encodeURIComponent(numeroNota)}/competencias`,
      payload,
    );

    const lista = Array.isArray(data) ? data : (data?.competencias ?? []);
    return lista.map(normalizaCompetencia);
  }

  useEffect(() => {
    (async () => {
      if (
        !checarData(formatDateBD(dataInicio)) ||
        !checarData(formatDateBD(dataFim))
      ) {
        setLoadingNotasFiscais(false);
        setTotalValorNotasSankhya(0);
        setNotasFiscaisTabela([]);
        return;
      }

      try {
        setLoadingNotasFiscais(true);
        const { data } = await api.get("/v2/faturamento/notasFiscais", {
          params: {
            dataInicio: formatDateBD(dataInicio),
            dataFim: formatDateBD(dataFim),
          },
        });

        setTotalValorNotasSankhya(data.totalValorNotas);
        setNotasFiscaisTabela(data.notasFiscais.map(normalizaNotaFiscal));
      } catch (error) {
        setTotalValorNotasSankhya(0);
        setNotasFiscaisTabela([]);
      } finally {
        setLoadingNotasFiscais(false);
      }
    })();
    // eslint-disable-next-line
  }, [dataInicio, dataFim]);

  return (
    <NotasFiscaisContext.Provider
      value={{
        totalValorNotasSankhya,
        notasFiscaisTabela,
        loadingNotasFiscais,
        buscarCompetenciasNota,
        salvarCompetenciasNota,
      }}
    >
      {children}
    </NotasFiscaisContext.Provider>
  );
}

export { NotasFiscaisContext, NotasFiscaisContextProvider };
